(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('emailAdd', {
        templateUrl: 'views/components/views/emailAdd/emailAdd.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'emailAddService', 'rememberService', function ($stateParams, stateService, utilityService, emailAddService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;
            let functionName = $stateParams.functionname;
            
            vm.model = {
                bgEmailAdd: {
                    selected: 'SUGGESTION',
                    buttons: [
                        { id: 'SUGGESTION', label: 'bg_emailadd_suggestion', color: 'primary', onClick: () => vm.model.bgEmailAdd.selected = 'SUGGESTION' },
                        { id: 'SEARCH', label: 'bg_emailadd_search', color: 'primary', onClick: () => vm.model.bgEmailAdd.selected = 'SEARCH' }
                    ]
                },
                bgEmailAddFunc: {
                    selected: 'SELECT',
                    buttons: [
                        { id: 'SELECT', label: 'bg_emailadd_func_select', color: 'primary', onClick: () => vm.model.bgEmailAddFunc.selected = 'SELECT' },
                        { id: 'GOTO', label: 'bg_emailadd_func_goto', color: 'primary', onClick: () => vm.model.bgEmailAddFunc.selected = 'GOTO' }
                    ]
                },
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
                    { id: 'search', icon: 'glyphicon glyphicon-search', color: 'primary', type: 'primary', onClick: () => loadSearchEmails() }
                ],
                info: {},
                itemsListSuggestions: [],
                itemsListSearchEmails: [],
                lockedEmailAdd: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTIONS

            async function loadInfo() {
                vm.model.info = (await emailAddService.getInfo({
                    argtype: argType,
                    argvalue: argValue,
                    functionname: functionName
                }))[0];

                return loadSuggestions();
            }
            
            async function loadSuggestions() {
                return vm.model.itemsListSuggestions = await emailAddService.loadEmailAddSuggestionList(vm.model.info);
            }
            
            async function loadSearchEmails() {
                vm.model.itemsListSearchEmails = await emailAddService.listSearchEmails(vm.model.info);
            }
            
            function rememberEmailsToAdd(emailsToAdd) {
                let variableNameEmailsToAdd = 'w_emailadd_emails_to_add_' + vm.model.info.functionname;

                if (utilityService.validateParmsValue(vm.model.info.functionname) !== true) return;
                if (utilityService.validateParmsValue(variableNameEmailsToAdd) !== true) return;
                if (utilityService.validateParmsValue(emailsToAdd) !== true) return;

                rememberService.remember(variableNameEmailsToAdd, emailsToAdd).then(function () {
                    vm.model.lockedEmailAdd = false;
                    stateService.back();
                });
            }

            // #endregion LOAD PROCEDURE FUNCTIONS

            // #region MULTI CLEAR FUNCTION

            function clear(id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.info.searchtext = '';
                        vm.model.itemsListSearchEmails = [];
                        break;
                    default:
                        break;
                }
            }

            // #endregion MULTI CLEAR FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgEmailAdd = function (value) {
                vm.model.bgEmailAdd.selected = value;
                vm.model.info.bg_emailadd = vm.model.bgEmailAdd.selected;
            };

            vm.selectBgEmailAddFunc = function (value) {
                vm.model.bgEmailAddFunc.selected = value;

                //if (vm.model.bgEmailAdd.selected === 'SEARCH' && vm.model.bgEmailAddFunc.selected === 'GOTO') {
                //    loadSearchEmails();
                //}
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region SEARCH BUTTON FUNCTION

            vm.searchEmailAddresses = function () {
                loadSearchEmails();
            };

            // #endregion SEARCH BUTTON FUNCTION

            // #region TOGGLE CHOSEN FUNCTIONS

            vm.toggleChosenSuggestion = function (item) {
                if (item.item_id === '0' || item.item_id === '-1') return;

                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            vm.toggleChosenSearch = function (item) {
                if (item.item_id === '0' || item.item_id === '-1') return;

                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            // #endregion TOGGLE CHOSEN FUNCTIONS

            // #region ADD BUTTON FUNCTION

            vm.addEmails = function () {
                let emailsToAdd = '';
                
                vm.model.itemsListSuggestions.forEach((item) => {
                    if (item.item_is_selected === '1' && item.email > '') {
                        emailsToAdd = emailsToAdd + item.email + '; ';
                    }
                });
                
                vm.model.itemsListSearchEmails.forEach((item) => {
                    if (item.item_is_selected === '1' && item.email > '') {
                        emailsToAdd = emailsToAdd + item.email + '; ';
                    }
                });

                if (emailsToAdd.length > 0) {
                    vm.model.lockedEmailAdd = true;
                }

                vm.model.info.emails_to_add = emailsToAdd;
                
                rememberEmailsToAdd(emailsToAdd);
            };

            // #endregion ADD BUTTON FUNCTION

            // #region ON BLUR MULTI FUNCTIONS

            vm.onBlur = function (id) {
                switch (id) {
                    case 'searchtext':
                        if (utilityService.validateParmsValue(vm.model.info.searchtext) !== true) return;

                        if (vm.model.info.searchtext > '') loadSearchEmails();
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'searchtext':
                        if (utilityService.validateWatchValue(value, vm.model.info.searchtext) !== true) return;

                        vm.model.info.searchtext = value;

                        if (utilityService.validateParmsValue(vm.model.info.searchtext, true) !== true) return;

                        if (vm.model.info.searchtext === '') loadSearchEmails();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadInfo();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
